module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "padding": "unset"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 serch-barr"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-3 col-sm-3 col-md-8 col-lg-8 col-xl-8"
  }, [_c('div', {
    staticClass: "searchBar",
    staticStyle: {
      "padding-top": "2%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchField),
      expression: "searchField"
    }],
    staticClass: "searchTerm",
    attrs: {
      "type": "text",
      "placeholder": "Search by Product Name / Code"
    },
    domProps: {
      "value": (_vm.searchField)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getAllProduct()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchField = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "searchButton",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    on: {
      "click": function($event) {
        return _vm.getAllProduct()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2"
  }, [_c('md-field', {
    staticClass: "dddBox"
  }, [_c('md-select', {
    staticClass: "dropDown",
    attrs: {
      "name": "orderBy",
      "id": "orderBy",
      "placeholder": "Sort Products"
    },
    on: {
      "md-selected": function($event) {
        return _vm.getAllProduct()
      }
    },
    model: {
      value: (_vm.selectedCate),
      callback: function($$v) {
        _vm.selectedCate = $$v
      },
      expression: "selectedCate"
    }
  }, _vm._l((_vm.allCategory), function(cata) {
    return _c('md-option', {
      key: cata.id,
      attrs: {
        "value": cata.id
      }
    }, [_vm._v(_vm._s(cata.name) + "\n                ")])
  }), 1)], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.allProduct), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3"
    }, [_c('div', {
      staticClass: "v-boxx"
    }, [_c('div', {
      staticClass: "v-videoo"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail_medium,
        "alt": "..."
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "v-content"
    }, [_c('div', {
      staticClass: "v-name two-line-overflow",
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "space-5px"
    }), _vm._v(" "), _c('div', {
      staticClass: "v-disc two-line-overflow",
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "space-5px"
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": 'products-view/single-product/' + item.id
      }
    }, [_c('button', {
      staticClass: "btn primary-btn-my"
    }, [_vm._v("View More")])])], 1)])])
  }), 0)])]), _vm._v(" "), (_vm.noContent === 'yes') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_vm._v("\n        No results found\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.noContentErrorMsg) ? _c('div', {
    staticClass: "row"
  }, [_c('vue-content-loading', {
    attrs: {
      "width": 300,
      "height": 100
    }
  }, [_c('rect', {
    attrs: {
      "x": "0",
      "y": "13",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "50"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "66",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "72",
      "rx": "2",
      "ry": "2",
      "width": "14%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "78",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "84",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "13",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "50"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "66",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "72",
      "rx": "2",
      "ry": "2",
      "width": "14%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "78",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "84",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "13",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "50"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "66",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "72",
      "rx": "2",
      "ry": "2",
      "width": "14%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "78",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "84",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "13",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "50"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "66",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "72",
      "rx": "2",
      "ry": "2",
      "width": "14%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "78",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "84",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.allProduct.length != 0) ? _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "page-item",
    class: {
      disable: _vm.pagination.current_page === _vm.pagination.from
    }
  }, [_c('a', {
    staticClass: "page-link",
    on: {
      "click": function($event) {
        _vm.pagination.current_page !== _vm.pagination.from && _vm.getAllProduct(_vm.pagination.first_page_url)
      }
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: {
      disable: !_vm.pagination.prev_page_url
    }
  }, [_c('a', {
    staticClass: "page-link",
    on: {
      "click": function($event) {
        _vm.pagination.current_page !== _vm.pagination.from && _vm.getAllProduct(_vm.pagination.prev_page_url)
      }
    }
  }, [_vm._v("<")])]), _vm._v(" "), _vm._l((_vm.pagination.last_page), function(n) {
    return _c('li', {
      key: n,
      staticClass: "page-item",
      class: {
        active: _vm.pagination.current_page == n
      }
    }, [_c('a', {
      staticClass: "page-link",
      on: {
        "click": function($event) {
          _vm.pagination.current_page !== n && _vm.getAllProduct(_vm.pagination.path + '&page=' + n)
        }
      }
    }, [_vm._v(_vm._s(n))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: {
      disable: !_vm.pagination.next_page_url
    }
  }, [_c('a', {
    staticClass: "page-link",
    on: {
      "click": function($event) {
        _vm.pagination.current_page !== _vm.pagination.last_page && _vm.getAllProduct(_vm.pagination.next_page_url)
      }
    }
  }, [_vm._v(">")])]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: {
      disable: !_vm.pagination.last_page_url
    }
  }, [_c('a', {
    staticClass: "page-link",
    on: {
      "click": function($event) {
        _vm.pagination.current_page !== _vm.pagination.last_page && _vm.getAllProduct(_vm.pagination.last_page_url)
      }
    }
  }, [_vm._v("»")])])], 2)]) : _vm._e()]), _vm._v(" "), _c('back-to-top', {
    attrs: {
      "bottom": "120px",
      "right": "20px",
      "visibleoffset": "20"
    }
  }, [_c('button', {
    staticClass: "scoller-top-btn",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-up"
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"
  }, [_c('p', {
    staticClass: "home-topic",
    staticStyle: {
      "padding-top": "11%"
    }
  }, [_vm._v("Products")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca883f72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/ProductsView.vue
// module id = 2119
// module chunks = 1